export const aggregateYearlyData = (monthlyData: number[]): number[] => {
  const yearlyData = [];
  const monthsInYear = 12;

  for (let i = monthsInYear; i <= monthlyData.length; i += monthsInYear) {
    if (monthsInYear >= monthlyData.length) {
      yearlyData.push(monthlyData[monthlyData.length - 1]);
    } else {
      yearlyData.push(monthlyData[i - 1]);
    }
  }
  return yearlyData;
};
